import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 400,
        flex: 1
    },
    container: {
        flexDirection: "column",
        flex: 1
    },
    contentWrapper: {
        flexDirection: "column",
        width: "100%"
    },
    unselectableText: {
        ...webStyle({
            userSelect: "none"
        })
    }
});
export default stylesheet;
